// TODO: This hack should not be needed, the calendar component should be able to handle
import { TextTokenEnum } from '@/Shared/AutoGenerated/LocalizationEnum'
import { type CalendarMonthType } from '@/Shared/AutoGenerated/Main'

// something if there is no data available yet and it is loading???
export default function useFakeCalendarData() {
    function get(): { months: CalendarMonthType[] } {
        const months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ]

        const now = new Date()
        const monthName = months[now.getMonth()]
        const year = now.getFullYear()

        return {
            months: [
                {
                    year: `${year}`,
                    monthName: `${monthName}`,
                    monthTextToken: TextTokenEnum.BookingForm_January,
                    weeks: [
                        {
                            days: [
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 1,
                                    date: '2024-12-01',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 2,
                                    date: '2024-12-02',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 3,
                                    date: '2024-12-03',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 4,
                                    date: '2024-12-04',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 5,
                                    date: '2024-12-05',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 6,
                                    date: '2024-12-06',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 7,
                                    date: '2024-12-07',
                                },
                            ],
                        },
                        {
                            days: [
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 8,
                                    date: '2024-12-08',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 9,
                                    date: '2024-12-09',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 10,
                                    date: '2024-12-10',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 11,
                                    date: '2024-12-11',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 12,
                                    date: '2024-12-12',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 13,
                                    date: '2024-12-13',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 14,
                                    date: '2024-12-14',
                                },
                            ],
                        },
                        {
                            days: [
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 15,
                                    date: '2024-12-15',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 16,
                                    date: '2024-12-16',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 17,
                                    date: '2024-12-17',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 18,
                                    date: '2024-12-18',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 19,
                                    date: '2024-12-19',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 20,
                                    date: '2024-12-20',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 21,
                                    date: '2024-12-21',
                                },
                            ],
                        },
                        {
                            days: [
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 22,
                                    date: '2024-12-22',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 23,
                                    date: '2024-12-23',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 24,
                                    date: '2024-12-24',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 25,
                                    date: '2024-12-25',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 26,
                                    date: '2024-12-26',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 27,
                                    date: '2024-12-27',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 28,
                                    date: '2024-12-28',
                                },
                            ],
                        },
                        {
                            days: [
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 29,
                                    date: '2024-12-29',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 30,
                                    date: '2024-12-30',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 31,
                                    date: '2024-12-31',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 1,
                                    date: '2025-01-01',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 2,
                                    date: '2025-01-02',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 3,
                                    date: '2025-01-03',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 4,
                                    date: '2025-01-04',
                                },
                            ],
                        },
                        {
                            days: [
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 5,
                                    date: '2025-01-05',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 6,
                                    date: '2025-01-06',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 7,
                                    date: '2025-01-07',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 8,
                                    date: '2025-01-08',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 9,
                                    date: '2025-01-09',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 10,
                                    date: '2025-01-10',
                                },
                                {
                                    isVisible: false,
                                    isAvailable: false,
                                    dayOfMonthNumber: 11,
                                    date: '2025-01-11',
                                },
                            ],
                        },
                    ],
                },
            ],
        }
    }

    return { get }
}
